<template>
  <v-data-table :headers="headers"
                :items="messages"
                :items-per-page="form.per_page"
                :footer-props="{'items-per-page-options': [5, 10, 25, 50, 100]}"
                :loading="loading"
                loading-text="Loading emails..."
                :server-items-length="pagination.total"
                dense
                @update:options="$emit('update:options', $event)">
    <template v-slot:item.recipients="{item: message}">
      <template v-if="message.userContact">
        <div v-if="message.userContact.name">
          {{ message.userContact.name }}
        </div>
        <div>
          {{ message.userContact.email }}
        </div>
      </template>
      <template v-else-if="message.recipients.data.length">
        <div v-for="recipient in message.recipients.data"
             :key="recipient.recipient_email">
          {{ recipient.recipient_email }}
        </div>
      </template>
    </template>
    <template v-slot:item.subject="{item: message}">
      <div class="d-block"
           :title="message.subject">
        {{ message.subject }}
      </div>
    </template>
    <template v-slot:item.created_at="{item: message}">
      <MessageLink :message="message"
                   :use-dialog="useDialog">
      </MessageLink>
    </template>
    <template v-slot:item.is_test="{item: message}">
      <div class="text-no-wrap">
        {{ message.is_test ? 'Test' : 'Real' }}
      </div>
    </template>
    <template v-slot:item.delivered_at="{item: message}">
      <v-icon v-if="message.delivered_at"
              color="success">
        fas fa-check-circle
      </v-icon>
    </template>
    <template v-slot:item.opened_at="{item: message}">
      <v-icon v-if="message.opened_at"
              color="success">
        fas fa-check-circle
      </v-icon>
    </template>
    <template v-slot:item.clicked_at="{item: message}">
      <v-icon v-if="message.clicked_at"
              color="success">
        fas fa-check-circle
      </v-icon>
    </template>
    <template v-slot:item.failed_at="{item: message}">
      <v-icon color="error"
              v-if="message.failed_at">
        fas fa-exclamation-triangle
      </v-icon>
    </template>
    <template v-slot:item.status="{item: message}">
      <message-status :message="message">
      </message-status>
    </template>
  </v-data-table>
</template>
<script>
import {mapGetters} from 'vuex';
import MessageLink from './MessageLink';
import MessageStatus from './MessageStatus';

export default {
  components: {MessageStatus, MessageLink},
  props: {
    form: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      required: false,
    },
    messages: {
      type: Array,
      required: true,
    },
    pagination: {
      type: Object,
      required: true,
    },
    useDialog: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'isAdmin',
      'isMember',
      'team',
      'user',
    ]),
    headers() {
      if (this.$root.isAdminRoute) {
        return [
          {text: 'Created', value: 'created_at', sortable: false,},
          {text: 'From', value: 'from_email', sortable: false,},
          {text: 'To', value: 'recipients', sortable: false,},
          {text: 'Subject', value: 'subject', sortable: false,},
          {text: 'Status', value: 'status', sortable: false,},
          {text: 'Type', value: 'is_test', sortable: false,},
          {text: 'Tag', value: 'tag', sortable: false,},
          //{text: 'Delivered', value: 'delivered_at'},
          //{text: 'Opened', value: 'opened_at', align: 'center'},
          //{text: 'Clicked', value: 'clicked_at', align: 'center'},
          //{text: 'Failed', value: 'failed_at'},
        ];
      }
      return [
        {text: 'Created', value: 'created_at', sortable: false,},
        {text: 'To', value: 'recipients', sortable: false,},
        {text: 'Subject', value: 'subject', sortable: false,},
        {text: 'Status', value: 'status', sortable: false,},
      ];
    }
  },
}
</script>
